"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(contentBlock) {
  var blockType = contentBlock.getType();
  var atomicType = contentBlock.getData().get('atomicType');
  return blockType === 'atomic' && atomicType === 'IMAGE';
};

exports.default = _default;
module.exports = exports.default;